import { render, staticRenderFns } from "./ResearchVolcanoPlotVector.vue?vue&type=template&id=6216db23"
import script from "./ResearchVolcanoPlotVector.vue?vue&type=script&lang=js"
export * from "./ResearchVolcanoPlotVector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6216db23')) {
      api.createRecord('6216db23', component.options)
    } else {
      api.reload('6216db23', component.options)
    }
    module.hot.accept("./ResearchVolcanoPlotVector.vue?vue&type=template&id=6216db23", function () {
      api.rerender('6216db23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/vectorPlots/ResearchVolcanoPlotVector.vue"
export default component.exports